module.exports = __webpack_public_path__ + "static/media/lock_icon.285fdab0.svg";